<template>
  <div
						class="mobileScreen-TS-cards m-3"
					>
						<div class="d-flex align-items-center m-3 justify-content-between">
							<div class="d-flex align-items-center">
								<div class="mobileScreen-TS-bluecard mr-3">Communication</div>

								<div class="mobileScreen-TS-bluecard">
									{{ questionData.questionBody.marks }} Mark
								</div>
							</div>
							<img
								@click="
									$emit('show-communication')
								"
								src="@/assets/communication/small-arrow.svg"
								alt
								class="pointer"
							/>
						</div>
						<div class="m-3">
							<div
								v-if="questionData.questionBody.questionMedia != null"
								class="mt-3"
							>
								<div
									@click.stop.prevent="$emit('open-image')
									"
									v-if="
										isImage(
											questionData.questionBody.questionMediaType
										)
									"
									class="d-flex align-items-center justify-content-center w-100"
								>
									<img
										class="qb-image-preview w-100"
										:src="questionData.questionBody.questionMedia"
										alt
									/>
								</div>
								<div
									v-if="
										isAudio(
											questionData.questionBody.questionMediaType
										)
									"
									class="d-flex align-items-center w-100"
								>
									<Media
										:kind="'audio'"
										:isMuted="false"
										:src="questionData.questionBody.questionMedia"
										:autoplay="false"
										:controls="true"
										:loop="true"
										class="mcqdatacard-audio-2 w-100"
									></Media>
								</div>
								<div
									v-if="
										isVideo(
											questionData.questionBody.questionMediaType
										)
									"
									class="d-flex align-items-center w-100"
								>
									<Media
										:kind="'video'"
										:isMuted="false"
										:src="questionData.questionBody.questionMedia"
										:autoplay="false"
										:controls="true"
										:loop="true"
										class="qb-image-preview w-100"
									></Media>
								</div>
							</div>
							<div class="d-flex my-3">
								<div class="mobileScreen-TS-cards-head">
									Q{{ questionData.questionNo ? questionData.questionNo : currentQuestionIndex + 1 }}. &nbsp;
								</div>
								<div
									v-html-safe="questionData.questionBody.question"
									class="mobileScreen-TS-cards-head"
								></div>
							</div>
						</div>
						<section v-if="questionData.answerStatus && questionData.answerStatus.attempted"
						>
						<div class="dashed-border"></div>
						<section class="d-flex flex-column audio-blue-sec">
							<div class="d-flex justify-content-between">
								<div class="d-flex align-items-center">
						<img
									src="@/assets/communication/your-answer.svg"
									alt=""
									class="mr-2"
								/>
						<span class="text-nowrap dark-gray font-primary fw-600 fs-13">
							Your Answer
						</span>
					</div>
					<b-button
						@click="$emit('show-communication')"
						class="btn-red d-flex align-items-center w-100px justify-content-center"
						>
						<h2 class="fs-13 font-secondary pure-white text-h2 font-secondary"
											>
												Retake
											</h2>
							</b-button>
							</div>
							
							<div
						class="answered-mob-audio-bar mt-3"
					>
					<section @click="togglePlayAudio">
							<img v-if="!isPlayingAudio" src="@/assets/communication/play.svg" />
							<img v-else src="@/assets/communication/pause.svg" />
						</section>

						<div ref="waveformaudio" class="waveform" style="height: 28px !important"></div>

						<div class="timer font-primary">
							{{ formattedTimeVal }}
						</div>
					</div>
						</section>
						</section>
						<hr />

						<div class="d-flex align-items-center justify-content-between m-3">
							<div class="mobileScreen-TS-mark-later">Mark for later</div>
							<div class="mobileScreen-SC-switch">
								<b-form-checkbox
									v-model="questionData.answerStatus.later"
									@change="$emit('mark-later')"
									switch
									size="sm"
									class="visibility-unselected-profile-switch"
								></b-form-checkbox>
							</div>
						</div>
					</div>
</template>

<script>
import AnsweredCommuMixin from "@/mixins/answeredCommuMixin";
import { isImage, isVideo, isAudio } from "@/checkFileType";
import Media from "@dongido/vue-viaudio";

export default {
    name: "CommunicationMobile",
    props:{
        questionData: Object,
        currentQuestionIndex: Number
    },
	components: {Media},
    mixins:[AnsweredCommuMixin],
    watch:{
        questionData(){
            this.checkAndGetAudio();
        }
    },
    created(){
		this.checkAndGetAudio();
    },
    methods:{
        isImage,
		isVideo,
		isAudio,
        checkAndGetAudio(){
            if(this.questionData.answer && typeof this.questionData.answer === "object" && this.questionData.answer.audioPath){
					this.getAudioData(this.questionData);
				}
        }
    }
}
</script>

<style>
.audio-blue-sec{
	background: #F7F9FC;
	height: 124;
	border-radius: 8px;
	gap: 12px;
	padding: 16px;
}

.answered-mob-audio-bar{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: #20639b14;
    border-radius: 100px;
    padding: 4px 20px;
    height: 48px;
}
</style>